import React from 'react';
import { useStore } from 'common/store';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { getArrayValue } from 'utilities';

const CapTableListSelection = (props: any) => {
  const { options: optionsProp, ...restProps } = props;
  const [{ capTableList }] = useStore();

  return (
    <GridSelect
      menuPosition="absolute"
      options={getArrayValue(optionsProp ?? capTableList)}
      objectOptions={{ displayKey: 'name', valueKey: 'id' }}
      {...restProps}
    />
  );
};

export default CapTableListSelection;
